var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { defaultIconProps } from '../icon';
export var IconCaretRight = function (props) { return (_jsx("span", __assign({ className: "icon icon__caret-right" }, { children: _jsx("svg", __assign({ "data-testid": "icon-caret-right", width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("path", { d: "M5.55565 12.3931C5.24616 12.0743 5.24616 11.5673 5.55565 11.2486L8.71005 8L5.55565 4.75141C5.24616 4.43268 5.24616 3.92565 5.55565 3.60693C5.87828 3.27466 6.41167 3.27466 6.7343 3.60693L10.3236 7.30337C10.7003 7.69138 10.7003 8.30862 10.3236 8.69663L6.7343 12.3931C6.41167 12.7253 5.87828 12.7253 5.55565 12.3931Z", fill: props.fill || defaultIconProps.fill }) })) }))); };
